"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserFeedbackOptionsValidator = void 0;
var defaultUserFeedbackOptions = {
    title: 'Feedback',
    hint: 'Please insert your feedback here and click send',
    subjectPlaceholder: 'Subject…',
    feedbackPlaceholder: 'Your feedback…',
    submitLabel: 'Send',
    closeLabel: 'Close',
};
/**
 * @internal
 */
var UserFeedbackOptionsValidator = /** @class */ (function () {
    function UserFeedbackOptionsValidator() {
    }
    UserFeedbackOptionsValidator.prototype.init = function (options) {
        return __assign(__assign({}, defaultUserFeedbackOptions), (options !== null && options !== void 0 ? options : {}));
    };
    return UserFeedbackOptionsValidator;
}());
exports.UserFeedbackOptionsValidator = UserFeedbackOptionsValidator;
